module.exports = __webpack_public_path__ + "7d2a8e5bb7fbdd47060ebcd25b817908.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/login/paper-plane2.png
// module id = 695
// module chunks = 0